import { WorkClassification } from "./types";

export const WorkClassificationToNCCI: Record<WorkClassification, string> = {
  [WorkClassification.Driving]: "7219", // Trucking: long distance
  [WorkClassification.AutoDetailing]: "7380", // Automobile service or repair centers
  [WorkClassification.ClaimsInspector]: "8742", // Outside salespersons or collectors
  [WorkClassification.Clerical]: "8810" // Clerical office employees
};
